import { useTranslation } from 'react-i18next';
import type { GroupListItemDataFragment, SubgroupListItemDataFragment } from '../GroupListing/GroupList.api';
import formatDate from './utils';
import { Card } from '@/components/common/Card';
import CardContent from '@/components/common/Card/CardContent';
import CardHeader from '@/components/common/Card/CardHeader';
import CardTitle from '@/components/common/Card/CardTitle';
import DetailItem from '@/components/common/DetailItem';

interface DetailCardProps {
    group?: GroupListItemDataFragment;
    subgroup?: SubgroupListItemDataFragment;
}

const DetailCard = ({ group, subgroup }: DetailCardProps) => {
    const { t } = useTranslation('groups');
    return (
        <div className="overflow-x-auto">
            <Card>
                <CardHeader className="pb-2">
                    <CardTitle className="flex items-center justify-between text-lg">
                        <span>{(subgroup ? subgroup.name : group?.name) || ''}</span>
                    </CardTitle>
                </CardHeader>
                <CardContent className="space-y-2 pt-0">
                    <DetailItem
                        label={t('detailCard.description')}
                        value={(subgroup ? subgroup.description : group?.description) || ''}
                    />
                    <div className="grid grid-cols-2 gap-4">
                        {subgroup && (
                            <>
                                <div>
                                    <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400">
                                        {t('detailCard.parentGroup')}
                                    </h4>
                                </div>
                                <DetailItem
                                    label={t('detailCard.memberCount')}
                                    value={t('detailCard.users', {
                                        count: group?.totalMemberCount,
                                    })}
                                />
                            </>
                        )}
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                        <DetailItem
                            label={t('detailCard.createdAt')}
                            value={formatDate(subgroup ? subgroup.createdAt : group?.createdAt)}
                        />

                        <DetailItem
                            label={t('detailCard.updatedAt')}
                            value={formatDate(subgroup ? subgroup.updatedAt : group?.updatedAt)}
                        />
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};

export default DetailCard;
